import React from 'react';
import '../buttons/saveCancelButtons/SaveCancelButtons.css';

export const Button = ({ onClick, children, type = 'button', variant = 'primary', size = 'medium', className = '', disabled = false,}) => {
  const classes = `btn btn-${variant} btn-${size} ${className}`;
  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}; 